import { DataSource } from "@mcleod/components";
import { AutogenLayoutEmailSettings } from "./autogen/AutogenLayoutEmailSettings";
import { TestEmailSettingsDisplayer } from "./TestEmailSettingsDisplayer";

export class EmailSettings extends AutogenLayoutEmailSettings {
    public bindToDataSource(dataSource: DataSource) {
        this.sourceEmailSettings.rebindComponentsTo(dataSource);
        this.sourceEmailSettings = dataSource;
    }

    public requireFields(value: boolean) {
        [ this.textboxEmail, this.textboxEmailProtocol, this.textboxEmailHost, this.textboxEmailPort ]
            .forEach(textbox => textbox.required = value);
    }

    async buttonTestEmailSettingsOnClick() {
        new TestEmailSettingsDisplayer().displayInDialog(this);
    }
}
